import { render, staticRenderFns } from "./ComplementaDomicilio.vue?vue&type=template&id=77d26aa7"
import script from "./ComplementaDomicilio.vue?vue&type=script&lang=js"
export * from "./ComplementaDomicilio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d26aa7')) {
      api.createRecord('77d26aa7', component.options)
    } else {
      api.reload('77d26aa7', component.options)
    }
    module.hot.accept("./ComplementaDomicilio.vue?vue&type=template&id=77d26aa7", function () {
      api.rerender('77d26aa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/completaInfo/ComplementaDomicilio.vue"
export default component.exports